function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const countElement = document.getElementById("CartCount");
      if (cart.item_count > 0) {
        countElement.textContent = cart.item_count;
        countElement.style.display = "inline-block";
      } else {
        countElement.style.display = "none";
      }
    });
}

// Optional: Run after any "Add to Cart" button is clicked
document.addEventListener("click", function (e) {
  if (
    e.target.matches('form[action^="/cart/add"] [type="submit"], .add-to-cart')
  ) {
    setTimeout(updateCartCount, 1000); // delay to allow Shopify to process
  }
});
